import React from 'react';

export default function Tabs({ tabs, activeTab, handleTab }) {
    const isActive = index => activeTab === index;

    return (
        <>
            <div className="text-lg font-medium text-cente border-b border-gray-200 mb-10">
                <ul className="flex -mb-px overflow-x-auto no-scrollbar">
                    {
                        tabs.map((tab, index) => {

                            return (
                                <li key={index} className="me-2">
                                    <button
                                      className={`inline-block p-4 border-b-2 hover:text-gray-60 ${isActive(index) ? 'text-blue-600 border-blue-500' : 'border-transparent hover:border-gray-300'}`}
                                      onClick={() => handleTab(index)}
                                    >
                                        {tab}
                                    </button>
                                </li>
                            );
                        })
                    }
                </ul>
            </div>
        </>
    );
}
